import { get } from './http';

export function listContributors(id, context) {
  return get(context, `playground/contributors/${id}`);
}

export function imageById(id, context) {
  return get(context, `playground/images/${id}`);
}

export function list(data, context) {
  return get(context, 'playgrounds', data);
}

export function adminCities(data, context) {
  return get(context, 'playground/cities', data);
}
